<div class="flex flex-col" style="max-height: 85vh;">

  <div class="flex justify-between items-start px-4 pt-4 pb-2 flex-shrink-0">
    <p class="font-semibold text-site">{{ data.promo?.title }}</p>
    <mat-icon class="text-gray-400 cursor-pointer" (click)="close()">close</mat-icon>
  </div>

  <div class="flex-1 overflow-y-auto py-2 space-y-4" style="min-height:0;">
    <div class="rounded-[6px] p-3">
      <div class="space-y-3">

        @if (getSelectedBuyItems().length > 0) {
          <div class="rounded-[6px] p-3 border-2 transition-colors"
            style="background-color: var(--card-bg); border-color: var(--border-color);"
            >
            <div class="flex items-center gap-2 mb-3 pb-2 border-b" style="border-color: var(--border-color);">
              @if (data.promo?.payload?.cheapestOffered === false) {
                <span class="text-primary font-semibold text-sm"
                >🛒 Produits Achetés</span>
              }
              @if (data.promo?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesBuyItemsGroupHaveReduction()) {
                <span
                  class="text-green-600 text-xs font-semibold bg-green-500/10 px-2 py-0.5 rounded ml-auto">
                  {{ getFixedAmountReductionBadge() }}
                </span>
              }
            </div>
            @for (item of getSelectedBuyItems(); track item.rule + '-' + item.product) {
              <div class="mb-2 pb-2 border-b last:border-b-0" style="border-color: var(--border-color);">
                @for (i of [].constructor(item.quantity); track i + '-' + idx; let idx = $index) {
                  <div [class.mt-2]="idx > 0">
                    <div class="flex justify-between items-start mb-1">
                      <div class="flex-1">
                        <div class="flex items-center flex-wrap gap-1">
                          <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
                          @if (item.rule.sizes?.length > 0) {
                            <span class="text-gray-400 text-xs">
                              ({{ getSizesText(item.rule.sizes) }})
                            </span>
                          }
                          @if (item.quantity > 1) {
                            <span class="text-gray-400 text-xs">#{{ idx + 1 }}</span>
                          }
                          @if (doesItemHaveReduction(item.rule.id, item.product.id) && data.promo?.payload?.reduction?.type === 'PERCENTAGE') {
                            <span
                              class="inline-block text-green-600 text-[10px] font-semibold bg-green-500/10 px-1.5 py-0.5 rounded">
                              {{ getReductionText() }}
                            </span>
                          }
                        </div>
                        @if (data.customizableItems[item.rule.id + '_' + item.product.id]) {
                          <div class="mt-1">
                            <button
                              type="button"
                              class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors underline"
                              [class.text-[#888888]]="!hasIncompleteRequired(item.rule.id, item.product.id, idx)"
                              [class.text-red-600]="hasIncompleteRequired(item.rule.id, item.product.id, idx)"
                              (click)="openCustomization(item.product, item.rule.id, idx)">
                              @if (isCustomized(item.rule.id, item.product.id, idx) || hasIncompleteRequired(item.rule.id, item.product.id, idx)) {
                                <mat-icon
                                  class="material-symbols-outlined text-sm mr-1">
                                  {{ hasIncompleteRequired(item.rule.id, item.product.id, idx) ? 'warning' : '' }}
                                </mat-icon>
                              }
                              {{ isCustomized(item.rule.id, item.product.id, idx)
                              ? (hasIncompleteRequired(item.rule.id, item.product.id, idx) ? 'Compléter' : 'Modifier')
                              : 'Personnaliser' }}
                            </button>
                          </div>
                        }
                        @if (getCustomizationSummary(item.rule.id, item.product.id, idx).trim() !== '') {
                          <div class="mt-2 ml-1">
                            <div class="rounded-md px-2 py-1.5 text-xs">
                              <div class="text-gray-400 leading-relaxed whitespace-pre-line">
                                {{ getCustomizationSummary(item.rule.id, item.product.id, idx) }}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="text-right mr-2">
                        @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
                          <div
                            class="text-xs text-gray-400 line-through">
                            {{ getItemBasePrice(item.rule.id, item.product.id, idx) | number:'1.2-2' }}€
                          </div>
                        }
                        <div class="font-semibold text-sm"
                          [class.text-green-600]="shouldShowGreenPrice(item.rule.id, item.product.id)"
                          [class.text-site]="!shouldShowGreenPrice(item.rule.id, item.product.id)">
                          {{ getItemDisplayPrice(item.rule.id, item.product.id, idx) | number:'1.2-2' }}€
                        </div>
                      </div>
                      <mat-icon class="cursor-pointer text-red-500 hover:text-red-700 transition-colors"
                        style="font-size:20px;width:20px;height:20px;flex-shrink:0;"
                        (click)="removeItem(item.rule.id, item.product.id, idx)">
                        delete
                      </mat-icon>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (getOfferedItems().length > 0) {
          <div class="rounded-[6px] p-3 border-2 transition-colors"
            style="background-color: var(--card-bg); border-color: var(--border-color);"
            >
            <div class="flex items-center gap-1 mb-3 pb-2 border-b" style="border-color: var(--border-color);">
              @if (data.promo?.payload?.cheapestOffered === false) {
                <span class="text-green-600 font-semibold text-sm"
                >🎁 Produits Offerts</span>
              }
              @if (data.promo?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesOfferedItemsGroupHaveReduction()) {
                <span
                  class="text-green-600 text-xs font-semibold bg-green-500/10 px-2 py-0.5 rounded ml-auto">
                  {{ getFixedAmountReductionBadge() }}
                </span>
              }
              @if (data.promo?.payload?.reduction?.type === 'SET_PRICE') {
                <div class="flex justify-end">
                  <span class="text-green-600 text-xs font-semibold bg-green-500/10 px-2 py-0.5 rounded ml-auto">
                    {{ data.promo?.payload?.reduction?.value | number:'1.2-2' }} €
                  </span>
                </div>
              }
            </div>
            @for (item of getOfferedItems(); track item.rule + '-' + item.product) {
              <div class="mb-2 pb-2 border-b last:border-b-0" style="border-color: var(--border-color);">
                @for (i of [].constructor(item.quantity); track i + '-' + idx; let idx = $index) {
                  <div [class.mt-2]="idx > 0">
                    <div class="flex justify-between items-start mb-1">
                      <div class="flex-1">
                        <div class="flex items-center flex-wrap gap-1">
                          <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
                          @if (item.rule.sizes?.length > 0) {
                            <span class="text-gray-400 text-xs">
                              ({{ getSizesText(item.rule.sizes) }})
                            </span>
                          }
                          @if (item.quantity > 1) {
                            <span class="text-gray-400 text-xs">#{{ idx + 1 }}</span>
                          }
                          @if (doesItemHaveReduction(item.rule.id, item.product.id) && data.promo?.payload?.reduction?.type === 'PERCENTAGE') {
                            <span
                              class="inline-block text-green-600 text-[10px] font-semibold bg-green-500/10 px-1.5 py-0.5 rounded">
                              {{ getReductionText() }}
                            </span>
                          }
                        </div>
                        @if (data.customizableItems[item.rule.id + '_' + item.product.id]) {
                          <div class="mt-1">
                            <button
                              type="button"
                              class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors underline text-[#FF730A]"
                              [class.text-[#888888]]="!hasIncompleteRequired(item.rule.id, item.product.id, idx)"
                              [class.text-red-600]="hasIncompleteRequired(item.rule.id, item.product.id, idx)"
                              (click)="openCustomization(item.product, item.rule.id, idx)">
                              @if (isCustomized(item.rule.id, item.product.id, idx) || hasIncompleteRequired(item.rule.id, item.product.id, idx)) {
                                <mat-icon
                                  class="material-symbols-outlined text-sm mr-1">
                                  {{ hasIncompleteRequired(item.rule.id, item.product.id, idx) ? 'warning' : '' }}
                                </mat-icon>
                              }
                              {{ isCustomized(item.rule.id, item.product.id, idx)
                              ? (hasIncompleteRequired(item.rule.id, item.product.id, idx) ? 'Compléter' : 'Modifier')
                              : 'Personnaliser' }}
                            </button>
                          </div>
                        }
                        @if (getCustomizationSummary(item.rule.id, item.product.id, idx).trim() !== '') {
                          <div class="mt-2 ml-1">
                            <div class="rounded-md px-2 py-1.5 text-xs">
                              <div class="text-gray-400 leading-relaxed whitespace-pre-line">
                                {{ getCustomizationSummary(item.rule.id, item.product.id, idx) }}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      @if (data.promo?.payload?.reduction?.type !== 'SET_PRICE') {
                        <div class="text-right mr-2">
                          @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
                            <div
                              class="text-xs text-gray-400 line-through">
                              {{ getItemBasePrice(item.rule.id, item.product.id, idx) | number:'1.2-2' }}€
                            </div>
                          }
                          <div class="font-semibold text-sm text-green-600">
                            {{ getItemDisplayPrice(item.rule.id, item.product.id, idx) | number:'1.2-2' }}€
                          </div>
                        </div>
                      }
                      <mat-icon class="cursor-pointer text-red-500 hover:text-red-700 transition-colors"
                        style="font-size:20px;width:20px;height:20px;flex-shrink:0;"
                        (click)="removeItem(item.rule.id, item.product.id, idx)">
                        delete
                      </mat-icon>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (getSelectedBuyItems().length === 0 && getOfferedItems().length === 0) {
          <div
            class="text-center text-gray-400 text-sm py-4">
            Sélectionnez vos produits
          </div>
        }

      </div>
    </div>
  </div>

  <div class="border-t px-4 py-4 flex-shrink-0 space-y-2 footer-container" style="border-color: var(--border-color);">
    @if (getTotalSupplementsPrice() > 0) {
      <div class="flex justify-between text-sm font-semibold pt-1" style="border-color: var(--border-color);"
        >
        <span class="text-site">Suppléments</span>
        <span class="text-green-600">+{{ getTotalSupplementsPrice() | number:'1.2-2' }}€</span>
      </div>
    }
    @if (getTotalReductionAmount() > 0) {
      <div class="flex justify-between text-sm font-semibold pt-1 border-t" style="border-color: var(--border-color);"
        >
        <span class="font-bold text-site">Total avant réduction</span>
        <span class="font-bold text-site">{{ getTotalBeforeReduction() | number:'1.2-2' }}€</span>
      </div>
    }

    @if (getTotalReductionAmount() > 0) {
      <div class="flex justify-between text-sm font-semibold pt-1 border-t" style="border-color: var(--border-color);"
        >
        <span class="text-site font-bold">Réduction</span>
        <span class="text-[#EB3D08]">-{{ getTotalReductionAmount() | number:'1.2-2' }}€</span>
      </div>
    }

    <div class="flex justify-between pt-2" style="border-color: var(--text-site);">
      <span class="text-site font-bold text-lg">Total</span>
      <span class="text-site font-bold text-xl">
        {{ calculatePromotionTotal() | number:'1.2-2' }}€
      </span>
    </div>

    @if (getValidationMessage() !== '') {
      <div class="p-3 bg-orange-500/10 border border-orange-500/30 rounded-[6px]">
        <p class="text-sm text-orange-500 flex items-center gap-1">
          <mat-icon style="font-size:16px;width:16px;height:16px">warning</mat-icon>
          {{ getValidationMessage() }}
        </p>
      </div>
    }

    <button (click)="confirmAddToCart()"
      [disabled]="!canAdd()"
            [matButton]="themeConfig.appearance.button.action"

            class="w-full "
      >
      Ajouter au panier
    </button>
  </div>
</div>
